import basketEffects from './basket/effects';
import exclusionEffects from './exclusions/effects';

const middleware = [basketEffects, exclusionEffects];

export default middleware;
